var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAs(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5003:52034)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7623 2.007C21.4633 0.729 18.8169 0 16 0C7.16413 0 0.001125 7.16238 0 15.9981L11.1304 10.4348L23.7623 2.007Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 16.0019C0.001125 24.8376 7.16413 32 16 32C18.8169 32 21.4633 31.2711 23.7623 29.993L11.1304 21.5652L0 16.0019Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.0956 2.83639C24.6659 2.53895 24.2206 2.26233 23.7617 2.00726L0 15.9981V16C0 16 0 16.0013 0 16.0019L23.7617 29.9927C24.2206 29.7376 24.6659 29.461 25.0957 29.1636L2.73887 16L25.0956 2.83639Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.8263 15.4033H25.9204C26.416 14.8083 26.3854 13.9232 25.8271 13.365C26.4185 12.7737 26.4185 11.8148 25.8271 11.2234L25.7915 11.2592C26.3828 10.6678 26.4185 9.67328 25.8271 9.08197L17.2611 17.648C17.8525 18.2394 18.7945 18.2323 19.3858 17.641L19.5507 17.4903L23.6524 17.1174V18.8815H25.0437V16.9909L27.1307 16.8012L27.8263 15.4033Z",
    fill: "#A2001D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3918 19.4782L16 18.7826L17.3918 18.0869H26.4352V19.4782H17.3918Z",
    fill: "#FFDA44"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5003:52034"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAs);
export default __webpack_public_path__ + "static/media/AS.41833d61.svg";
export { ForwardRef as ReactComponent };